import client from '../../../vendor/rshop/frontend/assets/js/common/client'
import { formatPrice } from '../../../vendor/rshop/frontend/assets/js/common/format'
import { updateLazy } from '../functions/lazy'
import { initTippy } from '../functions/tippy'

const lang = document.querySelector('html').getAttribute('lang')

let locale = {}

import(`../locale/${lang}`).then((module) => {
    locale = module
})

const detail = document.querySelector('.js-price-offer-detail')

// Prices are never recalculated here - every change is saved first and the backend answers
// with the recalculated row and offer totals, so the price logic lives in one place only.
if (detail) {
    const offerId = detail.dataset.offerId

    const parseNumber = (value) => {
        const parsed = parseFloat(String(value).replace(/\s/g, '').replace(',', '.'))

        return isNaN(parsed) ? null : parsed
    }

    const formatPercent = (value) => {
        return `${parseFloat(value).toFixed(2).replace(/\.?0+$/, '').replace('.', ',')} %`
    }

    const formatDecimal = (value) => {
        return parseFloat(value).toFixed(2).replace('.', ',')
    }

    const formatCompactDecimal = (value) => {
        return parseFloat(value).toFixed(2).replace(/\.?0+$/, '').replace('.', ',')
    }

    const setLoading = (row, isLoading) => {
        row.classList.toggle('is-loading', isLoading)
        row.querySelectorAll('.c-price-offer-input').forEach((input) => {
            input.classList.toggle('is-loading', isLoading)
        })
    }

    const renderTotals = (totals) => {
        const values = {
            'margin': formatPercent(totals.margin),
            'my-discount-amount': formatPrice(totals.my_discount_amount),
            'my-price': formatPrice(totals.my_price),
            'my-price-vat': formatPrice(totals.my_price_vat),
            'customer-price': formatPrice(totals.customer_price),
            'discount': formatPercent(totals.discount),
            'discount-amount': formatPrice(totals.discount_amount),
            'discounted': formatPrice(totals.customer_price_discounted),
            'discounted-vat': formatPrice(totals.customer_price_discounted_vat)
        }

        Object.keys(values).forEach((name) => {
            const element = detail.querySelector(`[data-total="${name}"]`)

            if (element) {
                element.innerHTML = values[name]
            }
        })
    }

    const renderRow = (row, product) => {
        const totals = product.totals
        const quantity = parseInt(totals.quantity, 10)
        const customPriceInput = row.querySelector('.js-price-offer-custom-price')
        const discountInput = row.querySelector('.js-price-offer-discount')

        row.querySelector('.js-price-offer-my-price').innerHTML = formatPrice(totals.my_price)
        row.querySelector('.js-price-offer-my-price-unit').innerHTML = `${quantity}x ${formatPrice(totals.my_price_unit)}`
        row.querySelector('.js-price-offer-margin').innerHTML = formatPercent(totals.margin)
        row.querySelector('.js-price-offer-discounted').innerHTML = formatPrice(totals.customer_price_discounted)

        customPriceInput.placeholder = formatDecimal(totals.my_price)

        // the customer price is entered per row, so a quantity change rewrites it
        if (document.activeElement !== customPriceInput) {
            customPriceInput.value = product.custom_price === null ? '' : formatDecimal(totals.customer_price)
        }

        if (document.activeElement !== discountInput) {
            discountInput.value = formatCompactDecimal(totals.discount)
        }
    }

    const save = (row, payload) => {
        setLoading(row, true)

        return client
            .post(`/cenove-ponuky/upravit-produkt/${offerId}`, Object.assign({
                product_id: row.dataset.productId
            }, payload))
            .then((response) => {
                if (!response.data.status || !response.data.product || !response.data.totals) {
                    Eshop.alert(response.data.message || locale.GeneralError, { type: 'error' })

                    return
                }

                renderRow(row, response.data.product)
                renderTotals(response.data.totals)
            })
            .catch(() => {
                Eshop.alert(locale.GeneralError, { type: 'error' })
            })
            .then(() => {
                setLoading(row, false)
            })
    }

    const quantityTimeouts = new WeakMap()

    const bindQuantity = (row) => {
        const spinner = row.querySelector('.js-price-offer-quantity')

        if (!spinner) {
            return
        }

        const onChange = () => {
            clearTimeout(quantityTimeouts.get(spinner))
            quantityTimeouts.set(spinner, setTimeout(() => {
                save(row, { quantity: spinner.getParsedValue() })
            }, 500))
        }

        spinner.addEventListener('changed', onChange)
        spinner.addEventListener('stop', onChange)
    }

    detail.querySelectorAll('.js-price-offer-row').forEach(bindQuantity)

    detail.addEventListener('change', (event) => {
        const row = event.target.closest('.js-price-offer-row')

        if (!row) {
            return
        }

        if (event.target.classList.contains('js-price-offer-custom-price')) {
            const value = parseNumber(event.target.value)
            const quantity = parseFloat(row.querySelector('.js-price-offer-quantity').getParsedValue()) || 1

            // the input holds the whole row, the backend stores the price per unit
            save(row, { custom_price: value === null ? '' : value / quantity })
        }

        if (event.target.classList.contains('js-price-offer-discount')) {
            save(row, { discount: parseNumber(event.target.value) || 0 })
        }
    })

    detail.addEventListener('click', (event) => {
        const trigger = event.target.closest('.js-price-offer-product-delete')

        if (!trigger || !locale.Swal) {
            return
        }

        const row = trigger.closest('.js-price-offer-row')

        Eshop.confirm(
            locale.Swal.DeletePriceOfferProduct.title,
            {
                denyButtonText: locale.Swal.DeletePriceOfferProduct.deny,
                confirmButtonText: locale.Swal.DeletePriceOfferProduct.confirm
            },
            () => {
                setLoading(row, true)

                client
                    .post(`/cenove-ponuky/zmazat-produkt/${offerId}`, { product_id: row.dataset.productId })
                    .then((response) => {
                        if (!response.data.status || !response.data.totals) {
                            Eshop.alert(response.data.message || locale.GeneralError, { type: 'error' })
                            setLoading(row, false)

                            return
                        }

                        if (!response.data.totals.products_count) {
                            window.location.reload()

                            return
                        }

                        row.remove()
                        renderTotals(response.data.totals)
                    })
                    .catch(() => {
                        Eshop.alert(locale.GeneralError, { type: 'error' })
                        setLoading(row, false)
                    })
            }
        )
    })

    const search = detail.querySelector('.js-price-offer-search')

    if (search) {
        const input = search.querySelector('.js-price-offer-search-input')
        const results = search.querySelector('.js-price-offer-search-results')
        const rows = detail.querySelector('.js-price-offer-rows')

        let searchTimeout = null
        let requestId = 0

        const closeResults = () => {
            search.classList.remove('is-open')
        }

        const searchProducts = () => {
            const keyword = input.value.trim()

            if (keyword.length < 2) {
                results.innerHTML = ''
                closeResults()

                return
            }

            const current = ++requestId

            search.classList.add('is-loading')

            client
                .get(`/cenove-ponuky/vyhladat-produkty/${offerId}`, { params: { q: keyword } })
                .then((response) => {
                    if (current !== requestId) {
                        return
                    }

                    results.innerHTML = response.data.html || ''
                    search.classList.toggle('is-open', Boolean(results.innerHTML))

                    updateLazy()
                })
                .catch(() => {
                    if (current === requestId) {
                        Eshop.alert(locale.GeneralError, { type: 'error' })
                    }
                })
                .then(() => {
                    if (current === requestId) {
                        search.classList.remove('is-loading')
                    }
                })
        }

        const insertRow = (html) => {
            const holder = document.createElement('div')
            holder.innerHTML = html.trim()

            const row = holder.firstElementChild

            if (!row) {
                return
            }

            const present = rows.querySelector(`.js-price-offer-row[data-product-id="${row.dataset.productId}"]`)

            if (present) {
                present.replaceWith(row)
            } else {
                rows.appendChild(row)
            }

            bindQuantity(row)
            updateLazy()
            initTippy()
        }

        const addProduct = (button) => {
            button.classList.add('is-loading')
            button.disabled = true

            client
                .post(`/cenove-ponuky/pridat-produkt/${offerId}`, {
                    product_id: button.dataset.productId,
                    quantity: 1,
                    render_row: 1
                })
                .then((response) => {
                    if (!response.data.status) {
                        Eshop.alert(response.data.message || locale.GeneralError, { type: 'error' })

                        return
                    }

                    if (!rows || !response.data.row || !response.data.totals) {
                        window.location.reload()

                        return
                    }

                    insertRow(response.data.row)
                    renderTotals(response.data.totals)
                    Eshop.alert(response.data.message, { type: 'success' })
                })
                .catch(() => {
                    Eshop.alert(locale.GeneralError, { type: 'error' })
                })
                .then(() => {
                    button.classList.remove('is-loading')
                    button.disabled = false
                })
        }

        input.addEventListener('input', () => {
            clearTimeout(searchTimeout)
            searchTimeout = setTimeout(searchProducts, 350)
        })

        input.addEventListener('focus', () => {
            if (results.innerHTML) {
                search.classList.add('is-open')
            }
        })

        results.addEventListener('click', (event) => {
            const button = event.target.closest('.js-price-offer-add')

            if (button) {
                addProduct(button)
            }
        })

        document.addEventListener('click', (event) => {
            if (!search.contains(event.target)) {
                closeResults()
            }
        })

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeResults()
            }
        })
    }

    const logoForm = detail.querySelector('.js-price-offer-logo')

    if (logoForm) {
        logoForm.querySelector('input[type="file"]').addEventListener('change', () => {
            logoForm.submit()
        })
    }

    const statusSelect = detail.querySelector('.js-price-offer-status-change')

    if (statusSelect) {
        statusSelect.addEventListener('change', (event) => {
            const offerId = event.target.dataset.offerId
            const statusId = parseInt(event.target.value, 10)

            if (!offerId || !statusId) {
                return
            }

            const originalValue = event.target.dataset.originalValue || event.target.value

            event.target.disabled = true

            client
                .post(`/cenove-ponuky/zmenit-stav/${offerId}`, { status_id: statusId })
                .then((response) => {
                    if (!response.data.status) {
                        Eshop.alert(response.data.message || locale.GeneralError, { type: 'error' })
                        event.target.value = originalValue
                        return
                    }

                    event.target.dataset.originalValue = statusId

                    const wrapper = event.target.closest('.c-price-offer-status')
                    if (wrapper && response.data.status_color) {
                        wrapper.className = wrapper.className.replace(/c-price-offer-status--\w+/g, '')

                        const modifiers = { 1: 'pending', 2: 'approved', 3: 'rejected' }
                        const modifier = modifiers[statusId] || 'pending'
                        wrapper.classList.add(`c-price-offer-status--${modifier}`)
                    }

                    Eshop.alert(response.data.message, { type: 'success' })
                })
                .catch(() => {
                    Eshop.alert(locale.GeneralError, { type: 'error' })
                    event.target.value = originalValue
                })
                .then(() => {
                    event.target.disabled = false
                })
        })

        // Store original value for rollback on error
        statusSelect.dataset.originalValue = statusSelect.value
    }
}
